import { Avatar, Badge, Dropdown, Menu, Space } from 'antd';
import {
  UserOutlined,
  KeyOutlined,
  LogoutOutlined,
  CodeFilled,
  GlobalOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Logo, Container, Notification } from './styles';
import { selectLang, setLang } from '../../slices/lang';
import { useDispatch, useSelector } from 'react-redux';
import { Lang } from '../../types';
import { useTheme } from 'styled-components';
import HeaderMenu from './menu';
import { useLocation, useNavigate } from 'react-router';
import { SVGLogoLight, SVGBell } from '../../images';
import {
  selectIsAdmin,
  selectIsSuperAdmin,
  selectRoles,
  selectUser,
  selectLicenses,
} from '../../slices/profile';
import { selectNotificationsNumber } from '../../slices/notifications';
import NotificationDrawer from '../../features/notification/notificationDrawer';
import DownloadLogModal from '../../components/downloadLogModal';
import ProfileCard from '../../components/profileCard';
import { useState } from 'react';

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const lang = useSelector(selectLang);
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const roles = useSelector(selectRoles);
  const isAdmin = useSelector(selectIsAdmin);
  const isSuperAdmin = useSelector(selectIsSuperAdmin);
  const notificationsNumber = useSelector(selectNotificationsNumber);
  const user = useSelector(selectUser);
  const licenses = useSelector(selectLicenses);

  const [showNotification, setShowNotification] = useState(false);
  const [showDownloadLogModal, setShowDownloadLogModal] = useState(false);

  const showHeaderMenu = pathname !== '/';

  const handleLangChange = (nextLang: Lang) => {
    if (nextLang === lang) return;
    i18n.changeLanguage(nextLang);
    dispatch(setLang(nextLang));
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const userMenuItems = [
    // 第一 section：用户信息和许可证（灰色背景卡片）
    {
      type: 'group',
      label: <ProfileCard user={user} licenses={licenses} />,
    } as any,
    {
      type: 'divider',
    } as any,
    {
      key: 'language',
      icon: <GlobalOutlined style={{ fontSize: 14 }} />,
      label: t('language'),
      style: { padding: '10px 16px' },
      children: [
        { key: Lang.en, label: t('english') },
        { key: Lang.de, label: t('german') },
      ],
    },
    {
      key: 'changePassword',
      icon: <KeyOutlined style={{ fontSize: 14 }} />,
      label: t('change_password'),
      onClick: () => navigate('/change-password'),
      style: { padding: '10px 16px', margin: '0 12px' },
    },
    {
      key: 'logout',
      icon: <LogoutOutlined style={{ fontSize: 14 }} />,
      label: t('log_out'),
      onClick: handleLogout,
      style: { padding: '10px 16px', margin: '0 12px' },
    },
  ];

  return (
    <Container gap={16} align="center">
      <Logo onClick={() => navigate('/')} align="center" justify="center">
        <SVGLogoLight />
      </Logo>
      <nav style={{ flex: 1 }}>{showHeaderMenu && <HeaderMenu />}</nav>
      {/* <Switch
        checkedChildren={lang}
        unCheckedChildren={lang === Lang.en ? Lang.de : Lang.en}
        onChange={handleLangChange}
      /> */}
      {(isSuperAdmin || isAdmin) && (
        <Menu
          items={[
            {
              key: 'userManagement',
              label: t('user_management'),
              onClick: () => navigate('/user'),
            },
          ]}
        ></Menu>
      )}
      {isSuperAdmin && (
        <Menu
          items={[
            {
              key: 'clientManagement',
              label: t('client_management'),
              onClick: () => navigate('/client'),
            },
          ]}
        ></Menu>
      )}
      {isSuperAdmin && (
        <Notification onClick={() => setShowDownloadLogModal(true)}>
          <CodeFilled style={{ color: '#F7F7F7', fontSize: 20 }} />
        </Notification>
      )}
      <Notification onClick={() => setShowNotification(true)}>
        <Badge count={notificationsNumber} size="small">
          <SVGBell fill="#F7F7F7" />
        </Badge>
      </Notification>
      <Dropdown
        menu={{
          items: userMenuItems,
          selectable: true,
          selectedKeys: [lang],
          onClick: ({ key }) => {
            if (key === Lang.en || key === Lang.de) {
              handleLangChange(key);
            }
          },
        }}
        placement="bottomRight"
        arrow={false}
        trigger={['click']}
        getPopupContainer={(trigger) => document.body}
        dropdownRender={(menu) => (
          <div
            style={{
              minWidth: '300px',
              padding: '4px',
            }}
          >
            {menu}
          </div>
        )}
      >
        <Space
          style={{
            cursor: 'pointer',
            borderRadius: 4,
          }}
          onClick={(e) => e.preventDefault()}
        >
          <Avatar
            style={{ backgroundColor: theme.antd.colorPrimary }}
            icon={<UserOutlined />}
          />
        </Space>
      </Dropdown>
      <NotificationDrawer
        open={showNotification}
        onClose={() => setShowNotification(false)}
      />
      <DownloadLogModal
        open={showDownloadLogModal}
        onClose={() => setShowDownloadLogModal(false)}
      />
    </Container>
  );
};

export default Header;
